export interface OrgNode {
  id: string;
  title: string;
  name: string;
  /** 职责说明（会员端协会介绍组织架构同步展示） */
  description?: string;
  level: number;
  parentId?: string;
  children?: OrgNode[];
}

const listeners = new Set<() => void>();

let _roots: OrgNode[] = [];

function notify(): void {
  listeners.forEach((fn) => fn());
}

export const orgStructureStore = {
  getRoots(): OrgNode[] {
    return JSON.parse(JSON.stringify(_roots)) as OrgNode[];
  },

  replaceFromApi(json: string): void {
    try {
      const parsed = JSON.parse(json) as unknown;
      _roots = Array.isArray(parsed) ? (parsed as OrgNode[]) : [];
    } catch {
      _roots = [];
    }
    notify();
  },

  setRoots(nodes: OrgNode[]): void {
    _roots = JSON.parse(JSON.stringify(nodes)) as OrgNode[];
    notify();
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
